export default [
  {
    path: 'retail',
    name: 'sale list',
    component: () => import('@/views/app/sale/retail/page-list.vue'),
    meta: { title: 'Daftar Penjualan' },
  },
  // {
  //   path: 'retail',
  //   name: 'sale list retail',
  //   component: () => import('@/views/app/sale/retail/page-list.vue'),
  //   meta: { title: 'Daftar Penjualan Retail' },
  // },
  // {
  //   path: 'online',
  //   name: 'sale list online',
  //   component: () => import('@/views/app/sale/online/page-list.vue'),
  //   meta: { title: 'Daftar Penjualan Online' },
  // },
  {
    path: 'cabang',
    name: 'sale list branch',
    component: () => import('@/views/app/sale/internal/page-list.vue'),
    meta: { title: 'Daftar Penjualan Cabang' },
  },
  {
    path: ':id',
    name: 'sale detail',
    component: () => import('@/views/app/sale/show/page-show.vue'),
    meta: { title: 'Detail Penjualan' },
  },
]
